module.exports = __webpack_public_path__ + "static/img/lifestyle_33.321b8999.png";